/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import clsx from 'clsx';
import {
    Grid,
    Paper,
    TextField,
    Button,
    Typography,
    Avatar,
    Box, InputAdornment, IconButton
} from '@mui/material'
import { Link, NavLink } from "react-router-dom"
import customStyles from "../../../../assets/styles/customStyles";
import { useDispatch, useSelector } from "react-redux";
import logoImg from "../../../../assets/images/logo.png"
import forgotPassImg from "../../../../assets/images/forgot-password.png";
import { Image } from "antd";
import { emptyValidation, customPassword, customPhoneValidation, customPasswordMatch } from "../../../../helpers/validation";
import actions from "../../redux/actions";
import usePrevious from "../../../Shared/components/Previous";
import { toast } from 'react-toastify';
import { checkLogin } from '../../../../helpers/utilities';
import Visibility from "../../../Shared/components/Icons/Visibility";
import VisibilityOff from "../../../Shared/components/Icons/VisibilityOff";

const ForgotPassword = (props) => {
    const { forgotPasswordLoader, forgotPasswordDetails, forgotPasswordError, verifyOtpLoader, verifyOtpDetails, verifyOtpError, resetPasswordLoader, resetPasswordDetails, resetPasswordError } = useSelector(state => state.authReducer);
    const [mobileOrEmail, setMobileOrEmail] = useState('');
    const [otp, setOtp] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const [forgotValidation, setForgotValidation] = useState(true);
    const [otpValidation, setOtpValidation] = useState(false);
    const [passwordValidation, setPasswordValidation] = useState(false);
    const dispatch = useDispatch();

    const [errorEmail, setErrorEmail] = useState(false);
    const [errorOtp, setErrorOtp] = useState(false);
    const [errorNewPassword, setErrorNewPassword] = useState(false);
    const [errorConfirmPassword, setErrorConfirmPassword] = useState(false);

    const prevForgotPasswordDetails = usePrevious(forgotPasswordDetails);
    const prevForgotPasswordError = usePrevious(forgotPasswordError);

    const prevResetPasswordDetails = usePrevious(resetPasswordDetails);
    const prevResetPasswordError = usePrevious(resetPasswordError);

    const prevVerifyOtpDetails = usePrevious(verifyOtpDetails);
    const prevVerifyOtpError = usePrevious(verifyOtpError);
    const [passwordNewShown, setPasswordNewShown] = useState(false);
    const [passwordConfirmShown, setPasswordConfirmShown] = useState(false);

    const { history } = props;

    const handleSubmit = (e) => {
        e.preventDefault();
        emptyState();
        let emptyEmail = emptyValidation('Mobile Number or Email', mobileOrEmail);
        if (emptyEmail.isValid) {
            dispatch({ type: actions.FORGOT_PASSWORD_START, data: { email: mobileOrEmail } });
        } else {
            if (emptyEmail.errors !== '') {
                setErrorEmail(emptyEmail.errors);
            }
        }
    }

    useEffect(() => {
        checkLogin(props);
    }, []);

    useEffect(() => {
        if (prevForgotPasswordDetails !== undefined && forgotPasswordDetails && prevForgotPasswordDetails !== forgotPasswordDetails) {
            setForgotValidation(false);
            setOtpValidation(true);
            toast.dismiss();
            toast('OTP sent successfully.');
            emptyState();
        } else if (prevForgotPasswordError !== undefined && forgotPasswordError && prevForgotPasswordError !== forgotPasswordError) {
            // if (forgotPasswordError.error.code === 'VALIDATION_FAILED') {
            //     setErrorEmail('Please enter valid mobile number or email');
            // } else {
            //     let error = forgotPasswordError.error.message.split("|");
            //     setErrorEmail(forgotPasswordError.error.message);
            //     if (error[0] === 'email') {
            //         setErrorEmail(forgotPasswordError.error.message);
            //     }
            // }
            setErrorEmail(forgotPasswordError?.error?.message);
        }
    }, [forgotPasswordDetails, forgotPasswordError]);

    const emptyState = () => {
        setErrorEmail(false);
        setErrorOtp(false);
        setErrorNewPassword(false);
        setErrorConfirmPassword(false);
    }

    const emptyStateInput = () => {
        setMobileOrEmail('');
        setOtp('');
        setNewPassword('');
        setConfirmPassword('');
    }

    const handleOtpSubmit = (e) => {
        e.preventDefault();
        emptyState();
        let emptyOtp = customPhoneValidation('Otp', otp, 6);
        if (emptyOtp.isValid) {
            dispatch({ type: actions.VERIFY_OTP_START, data: { otp: otp }, token: forgotPasswordDetails.token });
        } else {
            if (emptyOtp.errors !== '') {
                setErrorOtp(emptyOtp.errors);
            }
        }
    }

    useEffect(() => {
        if (prevVerifyOtpDetails !== undefined && verifyOtpDetails && prevVerifyOtpDetails !== verifyOtpDetails) {
            emptyState();
            setForgotValidation(false);
            setOtpValidation(false);
            setPasswordValidation(true);
        } else if (prevVerifyOtpError !== undefined && verifyOtpError && prevVerifyOtpError !== verifyOtpError) {
            if (verifyOtpError.error.code === 'VALIDATION_FAILED') {
                setErrorOtp('Please enter valid otp');
            } else {
                let error = verifyOtpError.error.message.split("|");
                if (error[0] === 'otp') {
                    setErrorOtp(error[1]);
                }
            }
        }
    }, [verifyOtpDetails, verifyOtpError]);


    const handleChangePasswordSubmit = (e) => {
        e.preventDefault();
        emptyState();
        let emptyNewPassword = customPassword('New Password', newPassword);
        let emptyConfirmPassword = customPasswordMatch('Confirm Password', newPassword, confirmPassword);
        if (emptyNewPassword.isValid && emptyConfirmPassword.isValid) {
            dispatch({ type: actions.RESET_PASSWORD_START, data: { newPassword: newPassword, confirmPassword: confirmPassword }, token: forgotPasswordDetails.token });

        } else {
            if (emptyNewPassword.errors !== '') {
                setErrorNewPassword(emptyNewPassword.errors);
            }
            if (emptyConfirmPassword.errors !== '') {
                setErrorConfirmPassword(emptyConfirmPassword.errors);
            }
        }
    }

    useEffect(() => {
        if (prevResetPasswordDetails !== undefined && resetPasswordDetails && prevResetPasswordDetails !== resetPasswordDetails) {
            emptyState();
            setForgotValidation(true);
            setOtpValidation(false);
            setPasswordValidation(false);
            toast(resetPasswordDetails);
            emptyStateInput();
            history.push('/login');
        } else if (prevResetPasswordError !== undefined && resetPasswordError && prevResetPasswordError !== resetPasswordError) {
            setErrorNewPassword(resetPasswordError.error.message);
        }
    }, [resetPasswordDetails, resetPasswordError]);


    const seneResendOtp = () => {
        dispatch({ type: actions.FORGOT_PASSWORD_START, data: { email: mobileOrEmail } });
        setOtp('');

    }

    const classes = customStyles();
    return (
        <div className={clsx(classes.backgroundWhite, classes.boxBorder1)}>
            <Paper className={clsx(classes.authContainer)} sx={{ p: 2 }}>
                <Grid container className={clsx(classes.authRoot, classes.fullHei)}>
                    <Link to="/login" className={clsx(classes.customLogoLink)}>
                        <Avatar
                            alt="Logo"
                            src={logoImg}
                            className={clsx(classes.customLogo)}
                            variant={'square'}
                        />
                    </Link>
                    <Grid xxl={7} xl={7} lg={7} md={7} sm={5} item className={classes.mobileDisplay}>
                        <Image
                            alt="Login"
                            preview={false}
                            src={forgotPassImg}
                            variant={'square'}
                        />
                    </Grid>
                    <Grid xxl={5} xl={5} lg={5} md={5} sm={7} xs={12} className={clsx(classes.cardSize, classes.loginForm)} item>
                        <Paper style={{ backgroundColor: 'transparent' }}>
                            {
                                forgotValidation &&
                                <>
                                    <Grid align='center'>
                                        <Typography variant="h6" className={clsx(classes.customTitle, classes.primaryFont, classes.bold)}>Forgot Password</Typography>
                                    </Grid>
                                    <Typography variant="h6" className={clsx(classes.margin40t, classes.fonSize14)}>
                                        Enter registered Mobile Number or Email ID to receive OTP
                                    </Typography>
                                    <Box
                                        className={clsx(classes.registerForm, classes.removeUnderline)}
                                        component="form"
                                        autoComplete="off"
                                        onSubmit={(e) => handleSubmit(e)}
                                    >
                                        <TextField autoComplete='one-time-code'
                                            label='Mobile Number or Email'
                                            fullWidth
                                            variant={'standard'}
                                            error={errorEmail && true}
                                            helperText={errorEmail}
                                            className={classes.margin30t}
                                            onChange={(e) => setMobileOrEmail(e.target.value)}
                                            InputProps={{
                                                classes: {
                                                    input: classes.textFieldColor,
                                                }
                                            }}
                                            InputLabelProps={{
                                                className: classes.textFieldLableColorCustom,
                                            }}
                                        />
                                        {/* <Typography className={clsx(classes.margin40t, classes.fonSize13)}>
                                            {"Didn't receive OTP "}
                                            <NavLink to={'#'} onClick={(e) => seneResendOtp(e)} className={clsx(classes.textDecoration, classes.fonSize13, classes.bold, classes.color)}>
                                                Resend OTP
                                            </NavLink>
                                        </Typography> */}
                                        <Button
                                            type='submit'
                                            color='primary'
                                            variant="contained"
                                            fullWidth
                                            className={clsx(classes.modalBtn, classes.margin40t, { [classes.loading]: forgotPasswordLoader })}
                                        >
                                            Send OTP
                                        </Button>
                                    </Box>
                                </>
                            }

                            {
                                otpValidation &&
                                <>
                                    <Grid align='center'>
                                        <Typography variant="h6" className={clsx(classes.customTitle, classes.primaryFont, classes.bold)}>OTP Verification</Typography>
                                    </Grid>
                                    <Typography variant="h6" className={clsx(classes.margin40t, classes.fonSize14)}>
                                        Enter registered Mobile Number or Email ID to receive OTP
                                    </Typography>
                                    <Box
                                        className={clsx(classes.registerForm, classes.removeUnderline)}
                                        component="form"
                                        autoComplete="off"
                                        onSubmit={(e) => handleOtpSubmit(e)}
                                    >
                                        <TextField autoComplete='one-time-code'
                                            label='Enter OTP'
                                            fullWidth
                                            type={'number'}
                                            onWheel={(e) => e.target.blur()}
                                            variant={'standard'}
                                            error={errorOtp && true}
                                            value={otp}
                                            helperText={errorOtp}
                                            className={classes.margin30t}
                                            onChange={(e) => e.target.value !== '' ? e.target.value < 0 ? setOtp((e.target.value = 0)) : setOtp(e.target.value) : setOtp(e.target.value)}
                                            InputProps={{
                                                classes: {
                                                    input: classes.textFieldColor,
                                                }
                                            }}
                                            InputLabelProps={{
                                                className: classes.textFieldLableColorCustom,
                                            }}
                                        />
                                        <Typography className={clsx(classes.margin40t, classes.fonSize13)}>
                                            {"Didn't receive OTP? "}
                                            <NavLink to={'#'} onClick={(e) => seneResendOtp(e)} className={clsx(classes.textDecoration, classes.fonSize13, classes.bold, classes.color)}>
                                                Resend OTP
                                            </NavLink>
                                        </Typography>
                                        <Button
                                            type='submit'
                                            color='primary'
                                            variant="contained"
                                            fullWidth
                                            className={clsx(classes.modalBtn, classes.margin40t, { [classes.loading]: verifyOtpLoader })}
                                        >
                                            Verify OTP
                                        </Button>
                                    </Box>
                                </>
                            }

                            {
                                passwordValidation &&
                                <>
                                    <Grid align='center'>
                                        <Typography variant="h6" className={clsx(classes.customTitle, classes.primaryFont, classes.bold)}>Reset Password</Typography>
                                    </Grid>
                                    <Box
                                        className={clsx(classes.registerForm, classes.removeUnderline)}
                                        component="form"
                                        autoComplete="off"
                                        onSubmit={(e) => handleChangePasswordSubmit(e)}
                                    >
                                        <TextField autoComplete='one-time-code'
                                            label='New Password'
                                            type={passwordNewShown ? "text" : "password"}
                                            fullWidth
                                            variant={'standard'}
                                            error={errorNewPassword && true}
                                            helperText={errorNewPassword}
                                            className={classes.margin30t}
                                            onChange={(e) => setNewPassword(e.target.value)}
                                            InputProps={{
                                                classes: {
                                                    input: classes.textFieldColor,
                                                },
                                                endAdornment: (
                                                    <InputAdornment className={classes.passwordIcon} onClick={() => setPasswordNewShown(!passwordNewShown)} position="end" >
                                                        <IconButton tabIndex={-1}>
                                                            {passwordNewShown ? <Visibility /> : <VisibilityOff />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                            }}
                                            InputLabelProps={{
                                                className: classes.textFieldLableColorCustom,
                                            }}
                                        />
                                        <TextField autoComplete='one-time-code'
                                            label='Confirm Password'
                                            type={passwordConfirmShown ? "text" : "password"}
                                            fullWidth
                                            variant={'standard'}
                                            error={errorConfirmPassword && true}
                                            helperText={errorConfirmPassword}
                                            className={classes.margin30t}
                                            onChange={(e) => setConfirmPassword(e.target.value)}
                                            InputProps={{
                                                classes: {
                                                    input: classes.textFieldColor,
                                                },
                                                endAdornment: (
                                                    <InputAdornment className={classes.passwordIcon} onClick={() => setPasswordConfirmShown(!passwordConfirmShown)} position="end" >
                                                        <IconButton tabIndex={-1}>
                                                            {passwordConfirmShown ? <Visibility /> : <VisibilityOff />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                            }}
                                            InputLabelProps={{
                                                className: classes.textFieldLableColorCustom,
                                            }}
                                        />
                                        <Button
                                            type='submit'
                                            color='primary'
                                            variant="contained"
                                            fullWidth
                                            className={clsx(classes.modalBtn, classes.margin40t, { [classes.loading]: resetPasswordLoader })}
                                        >
                                            Save New Password
                                        </Button>
                                    </Box>
                                </>
                            }
                        </Paper>
                    </Grid>
                </Grid >
            </Paper >
        </div >
    )
}

export default ForgotPassword